import React from "react";
import { Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { boxClasses } from "../../utils/classes";
import { Button, OutlinedButton } from "../../components/Button";

interface IAboutDrawerProps {
  open: boolean;
  close: () => void;
}

const AboutDrawer: React.FC<IAboutDrawerProps> = ({
  open,
  close,
}: IAboutDrawerProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" sx={boxClasses}>
      <Box margin="auto">
        <Typography
          variant="h3"
          component="h3"
          fontSize={24}
          color={theme.palette.text.primary}
          textAlign={"left"}
          mb={theme.spacing(5)}
        >
          What is DENTNet Bridge?
        </Typography>
        <Typography variant="body1" mb={8}>
          DENTNet Bridge is a bi-directional bridge to allow transfer of the
          DENT token between Ethereum and DENTNet.
        </Typography>
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
          <Button onClick={() => close()}>OK</Button>
          <a
            rel="noopener noreferrer"
            href={process.env.REACT_APP_SUPPORT_URL}
            target="_blank"
          >
            <OutlinedButton variant="outlined">
              Ask a question on {process.env.REACT_APP_SUPPORT_SERVICE}
            </OutlinedButton>
          </a>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutDrawer;
